import React, { useCallback, useEffect, useMemo } from "react";
import { useAppSelector } from "../../../store/index.ts";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import { ENUM_ELEMENT_NAME } from "../../common/enums.js";
import { useEventListener } from "usehooks-ts";

// если разница между значениями когда скрывать/показывать небольшая то нечего не делаем
const fixedClass = "fixed";
const DELAY_PX = 10;

export default function ChatBottomFixed({ ChatSendRef, className, ChatSendSendRef, children }) {
  const messages = useAppSelector((state) => state.chat.messages);
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);
  const isIphone = useAppSelector((state) => state.deviceSize.isIphone);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const messageLength = useMemo(() => messages?.length, [messages]);

  const scrollTimeout = useCallback(() => {
    if (isKeyboardOpen) return;

    const innerHeight = window.innerHeight;
    const scrollY = window.scrollY;

    const bottomSection = document.getElementsByName(ENUM_ELEMENT_NAME.streamProfile)?.[0];
    if (!bottomSection) return;
    const stopFixed = bottomSection?.offsetTop;
    const sendTop = innerHeight + scrollY + DELAY_PX;
    const isFixed = sendTop - stopFixed;

    // игнорируем барьер около нескольних px
    if (Math.abs(isFixed) < DELAY_PX) return;

    if (isFixed < 0) {
      ChatSendRef.current?.classList?.add?.(fixedClass);
    } else {
      ChatSendRef.current?.classList?.remove?.(fixedClass);
    }
  }, [ChatSendSendRef, ChatSendRef, isKeyboardOpen]);

  useEventListener("scroll", scrollTimeout);
  useEventListener("dragSize", scrollTimeout);
  useEventListener("resize", scrollTimeout);

  const scrollToCanvas = () => {
    const cbScroll = () => {
      const canvas = document.getElementsByName(ENUM_ELEMENT_NAME.streamWindow)[0];
      const sendHeight = ChatSendSendRef.current?.clientHeight || 0;
      if (!canvas) return;
      const canvasBottom = canvas.getBoundingClientRect()?.bottom;
      const elementBottom = canvasBottom + window.scrollY + sendHeight;
      const visibleHeight = window.visualViewport?.height || window.innerHeight;
      const scrollTarget = Math.min(
        elementBottom - visibleHeight,
        document.documentElement.scrollHeight - visibleHeight
      );

      isIphone
        ? canvas.scrollIntoView({ behavior: "smooth", block: "end" })
        : window.scrollTo({ top: scrollTarget, behavior: "smooth" });
    };

    // Ждём два кадра, чтобы браузер пересчитал layout
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        cbScroll();
        if (isIphone) {
          setTimeout(() => cbScroll(), 500);
        }
      })
    );
  };

  useEffect(() => {
    const canvas = document.getElementsByName(ENUM_ELEMENT_NAME.streamWindow)?.[0];
    const sendHeight = ChatSendSendRef.current?.clientHeight || 0;

    isKeyboardOpen
      ? ChatSendRef.current?.classList?.add?.(fixedClass)
      : ChatSendRef.current?.classList?.remove?.(fixedClass);

    if (!isFullScreen && isIphone && canvas) {
      const paddingBottom = isKeyboardOpen ? sendHeight + 6 + "px" : 0;
      canvas.style.paddingBottom = paddingBottom;
    }

    if (isKeyboardOpen && !isFullScreen) scrollToCanvas();
  }, [isFullScreen, isKeyboardOpen, messageLength]);

  useEffect(() => {
    scrollTimeout();
  }, [messageLength]);

  const onSendClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className={className} onClick={onSendClick} ref={ChatSendSendRef}>
      {children}
    </div>
  );
}
